export default {"src":"/_next/static/media/google-banner-2.c455665a.svg","height":120,"width":188,"blurWidth":0,"blurHeight":0};